import { CALL_APP_URL } from "./callAppUrl";

export const CALL_EMBED_MESSAGE_SOURCE = "bezpart-call";

export type CallEmbedMessage = {
  source: typeof CALL_EMBED_MESSAGE_SOURCE;
  inCall: boolean;
};

export type CallEmbedSyncRequest = {
  source: typeof CALL_EMBED_MESSAGE_SOURCE;
  type: "sync";
};

export function isCallEmbedMessage(data: unknown): data is CallEmbedMessage {
  return (
    typeof data === "object" &&
    data !== null &&
    (data as CallEmbedMessage).source === CALL_EMBED_MESSAGE_SOURCE &&
    typeof (data as CallEmbedMessage).inCall === "boolean"
  );
}

export function isCallEmbedSyncRequest(data: unknown): data is CallEmbedSyncRequest {
  return (
    typeof data === "object" &&
    data !== null &&
    (data as CallEmbedSyncRequest).source === CALL_EMBED_MESSAGE_SOURCE &&
    (data as CallEmbedSyncRequest).type === "sync"
  );
}

const LEGACY_CALL_ORIGINS = [
  "https://sfu.bezpart-server.ru",
  "https://bezpart-server.ru",
];

export function callEmbedAllowedOrigins(iframeSrc?: string): Set<string> {
  const origins = new Set<string>();
  for (const raw of [CALL_APP_URL, iframeSrc, ...LEGACY_CALL_ORIGINS]) {
    if (!raw?.trim()) continue;
    try {
      origins.add(new URL(raw).origin);
    } catch {
      /* ignore */
    }
  }
  return origins;
}

export function callEmbedAllowedOrigin(origin: string, iframeSrc?: string): boolean {
  return callEmbedAllowedOrigins(iframeSrc).has(origin);
}

export function requestCallEmbedSync(
  iframe: HTMLIFrameElement | null | undefined
): void {
  iframe?.contentWindow?.postMessage(
    { source: CALL_EMBED_MESSAGE_SOURCE, type: "sync" },
    "*"
  );
}
